// authApi.js
import { API_CONFIG } from "../utils/api-config";
import axios from "axios";

export const sendMail = async (data) => {
  try {
    const response = await axios.post(
      `${API_CONFIG.baseURL}/send-mail`,
      data, // Send data in the request body
      { headers: {...API_CONFIG.headers, secrete:"zozokart-mail"} } // Pass headers correctly
    );
    // console.log('response',response)
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    console.log(error)
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.response?.data?.message || "Login failed",
      statusCode: error?.response?.data?.status || 500 // Preserve status code
    };
  }
};
